import http from '../utils/http';
import i18n from '@/main';

export default {
    findByFiltro(filtro) {
        return http.post({
            url: '/areasmonitoradas/find',
            data: filtro,
            lockMessage: i18n.t('mensagens.sistema.buscandoAreasEspaciaisDeMonitoramento'),
            lockScreen: false
        });
    },

    findByFiltroPaginado(body, { page, size, sort }) {
        return http.post({
            url: `/areasmonitoradas/filtrar?page=${
                page - 1
            }&size=${size}&sort=${sort}`,
            data: body,
            lockScreen: false
        });
    },

    buscarAreasMonitoradasSocioambiental(
        filtros,
        { pagina, tamanho, ordenacao }
    ) {
        return http.post({
            url: `/monitoramento/socioambiental/areas-monitoradas?page=${pagina}&size=${tamanho}&sort=${ordenacao}`,
            data: filtros,
            lockScreen: false
        });
    },
    buscarTotalizadoresMonitoradasSocioambiental(
        filtros
    ) {
        let url = `/monitoramento/socioambiental/totalizadores`;
        
        return http.post({
            url: url,
            data: filtros,
            lockScreen: false
        });
    },

    getQuantitativos(filtro) {
        return http.get({
            url: '/areasmonitoradas/quantitativos',
            data: filtro,
            lockMessage: i18n.t('mensagens.sistema.buscandoQuantitativosDeAreas'),
            lockScreen: false
        });
    },

    findById(id) {
        return http.get({
            url: `/areasmonitoradas/${id}`,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDaAreaMonitorada')
        });
    },

    historicoAgro(idAreaMonitorada) {
        return http.get({
            url: `/areasmonitoradas/historico/agro/${idAreaMonitorada}`,
            lockScreen: false
        });
    },

    historicoClimatico(idAreaMonitorada) {
        return http.get({
            url: `/areasmonitoradas/historico/climatico/${idAreaMonitorada}`,
            lockScreen: false
        });
    },

    geometriaHistoricoAgro(idAreaMonitorada, idSafra) {
        return http.get({
            url: `/areasmonitoradas/historico/agro/geometria`,
            data: { idAreaMonitorada, idSafra },
            lockScreen: false
        });
    },

    analiseSocioambiental(idAreaMonitorada) {
        return http
            .get({
                url: `/areasmonitoradas/${idAreaMonitorada}/analisesocioambiental`,
                lockScreen: false
            })
            .then(result => {
                if (typeof result.data === 'string') {
                    result.data = JSON.parse(result.data);
                }
                return result;
            });
    },

    findFiltros() {
        return http.get({
            url: `/areasmonitoradas/filtros`,
            lockScreen: false
        });
    },

    desativarMonitoramentos(idsAreaMonitorada) {
        return http.put({
            url: '/areasmonitoradas/remover-areas-monitoramentos',
            data: idsAreaMonitorada,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.desativando')
        });
    }
};
